import { createI18n } from "vue-i18n";
import nl from "../assets/languages/nl";
import en from "../assets/languages/en";

export const i18n = createI18n({
  legacy: true,
  locale: "nl",
  fallbackLocale: "nl",
  messages: {
    nl: nl,
    en: en,
  },
});
